import React from 'react';
import { MenuItem, OutlinedTextFieldProps, SelectProps } from '@material-ui/core';
import { TextField, TextFieldProps } from '../../../ui-kit';
import Field, { FieldProps } from './Field';
import { Options } from './types';

export type SelectFieldProps<T> = OutlinedTextFieldProps & SelectProps & Omit<FieldProps<T, TextFieldProps>, 'renderer'> & {
    options: Array<Options>;
    showEmpty?: boolean;
};

const SelectField = <T, >({ options, placeholder, showEmpty, ...other }: SelectFieldProps<T>) => (
    <Field
        renderer={TextField}
        select
        {...other}
    >
        {placeholder && (<MenuItem value="" disabled>{placeholder}</MenuItem>)}
        {showEmpty && (<MenuItem value='null'>&mdash;</MenuItem>)}
        {options.map((option = { id: '', name: '' }) => (
            <MenuItem key={option.id || ''} value={option.id || ''}>
                {option.name || ''}
            </MenuItem>
    ))}
    </Field>
);

export default SelectField;
